import { docodeHexResponse } from '../../_common/common.utils';
import savingsActionTypes from './savings.types';

const INITIAL_STATE = {
	addSavingsDetailsResponse: null,
	updateSavingsDetailsResponse: null,

	getSavingsListResponse: null,
	getSavingsListArr: [],

	fetchSavingsDetailsResponse: null,
	fetchSavingsDetailsArr: [],

	deleteThriftSavingsResponse: null,

	fetchAllSavingsListResponse: null,
	fetchAllSavingsListArr: [],
};

const savingsReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** START ADD SAVINGS DETAILS ******************/
		case savingsActionTypes.ADD_SAVINGS_DETAILS_SUCCESS:
			return { ...state, addSavingsDetailsResponse: action.payload };

		case savingsActionTypes.ADD_SAVINGS_DETAILS_FAILURE:
			return { ...state, addSavingsDetailsResponse: action.payload };

		case savingsActionTypes.ADD_SAVINGS_DETAILS_RESPONSE_CHANGED:
			return { ...state, addSavingsDetailsResponse: null };
		/*************** END ADD SAVINGS DETAILS ******************/

		/*************** START UPDATE SAVINGS DETAILS ******************/
		case savingsActionTypes.UPDATE_SAVINGS_DETAILS_SUCCESS:
			return { ...state, updateSavingsDetailsResponse: action.payload };

		case savingsActionTypes.UPDATE_SAVINGS_DETAILS_FAILURE:
			return { ...state, updateSavingsDetailsResponse: action.payload };

		case savingsActionTypes.UPDATE_SAVINGS_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateSavingsDetailsResponse: null };
		/*************** END UPDATE SAVINGS DETAILS ******************/

		/** ***************** GET SAVINGS LIST START *********************** */
		case savingsActionTypes.GET_SAVINGS_LIST_SUCCESS:
			return {
				...state,
				getSavingsListResponse: action.payload,
				getSavingsListArr: docodeHexResponse(action.payload, 'GetSavingsListKey'),
			};

		case savingsActionTypes.GET_SAVINGS_LIST_FAILURE:
			return { ...state, getSavingsListResponse: action.payload, getSavingsListArr: [] };

		case savingsActionTypes.GET_SAVINGS_LIST_RESPONSE_CHANGED:
			return { ...state, getSavingsListResponse: null };
		/** ***************** GET SAVINGS LIST END *********************** */

		/** ***************** FETCH SAVINGS DETAILS START *********************** */
		case savingsActionTypes.FETCH_SAVINGS_DETAILS_SUCCESS:
			return {
				...state,
				fetchSavingsDetailsResponse: action.payload,
				fetchSavingsDetailsArr: docodeHexResponse(action.payload, 'FetchSavingsDetailsKey'),
			};

		case savingsActionTypes.FETCH_SAVINGS_DETAILS_FAILURE:
			return {
				...state,
				fetchSavingsDetailsResponse: action.payload,
				fetchSavingsDetailsArr: [],
			};

		case savingsActionTypes.FETCH_SAVINGS_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchSavingsDetailsResponse: null };
		/** ***************** FETCH SAVINGS DETAILS END *********************** */

		/** ***************** DELETE SAVINGS DETAILS START *********************** */
		case savingsActionTypes.DELETE_SAVINGS_DETAILS_SUCCESS:
			return { ...state, deleteThriftSavingsResponse: action.payload };

		case savingsActionTypes.DELETE_SAVINGS_DETAILS_FAILURE:
			return { ...state, deleteThriftSavingsResponse: action.payload };

		case savingsActionTypes.DELETE_SAVINGS_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteThriftSavingsResponse: null };
		/** ***************** DELETE SAVINGS DETAILS END *********************** */

		/** ***************** FETCH ALL SAVINGS LIST START *********************** */
		case savingsActionTypes.FETCH_ALL_SAVINGS_SUCCESS:
			return {
				...state,
				fetchAllSavingsListResponse: action.payload,
				fetchAllSavingsListArr: docodeHexResponse(action.payload, 'FetchAllSavingsKey'),
			};

		case savingsActionTypes.FETCH_ALL_SAVINGS_FAILURE:
			return { ...state, fetchAllSavingsListResponse: action.payload };

		case savingsActionTypes.FETCH_ALL_SAVINGS_RESPONSE_CHANGED:
			return { ...state, fetchAllSavingsListResponse: null };
		/** ***************** FETCH ALL SAVINGS LIST END *********************** */

		default:
			return state;
	}
};

export default savingsReducer;
